import { Tooltip as ChakraTooltip, Portal } from '@chakra-ui/react'
import * as React from 'react'

export interface TooltipProps extends Omit<
  ChakraTooltip.RootProps,
  'children'
> {
  children: React.ReactNode
  showArrow?: boolean
  portalled?: boolean
  portalRef?: React.RefObject<HTMLElement | null>
  content?: React.ReactNode
  contentProps?: ChakraTooltip.ContentProps
  disabled?: boolean
  label?: React.ReactNode
  hasArrow?: boolean
  isDisabled?: boolean
  placement?: string
  closeOnClick?: boolean
}

export const Tooltip = React.forwardRef<HTMLDivElement, TooltipProps>(
  function Tooltip(props, ref) {
    const {
      showArrow,
      hasArrow,
      children,
      disabled,
      isDisabled,
      portalled = true,
      content,
      label,
      contentProps,
      portalRef,
      placement,
      closeOnClick,
      ...rest
    } = props

    const isDisabledCompat = disabled ?? isDisabled
    const shouldShowArrow = showArrow ?? hasArrow
    const tooltipContent = content ?? label

    if (isDisabledCompat || !tooltipContent) return children

    const positioning = placement
      ? { placement: placement as any }
      : rest.positioning

    const defaultContentProps: ChakraTooltip.ContentProps = {
      bg: 'bg.inverted',
      color: 'fg.inverted',
      ...contentProps,
    }

    return (
      <ChakraTooltip.Root
        {...rest}
        positioning={positioning}
        closeOnPointerDown={closeOnClick ?? rest.closeOnPointerDown}
      >
        <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
        <Portal disabled={!portalled} container={portalRef}>
          <ChakraTooltip.Positioner>
            <ChakraTooltip.Content ref={ref} {...defaultContentProps}>
              {shouldShowArrow && (
                <ChakraTooltip.Arrow>
                  <ChakraTooltip.ArrowTip />
                </ChakraTooltip.Arrow>
              )}
              {tooltipContent}
            </ChakraTooltip.Content>
          </ChakraTooltip.Positioner>
        </Portal>
      </ChakraTooltip.Root>
    )
  },
)
